import React from "react";
import "./PcaAbout.css";

function PcaAbout() {
  return (
    <section className="pca-about" id="about">
      <div className="pca-about__inner">
        <div className="pca-about__heading">
          <div className="pca-about__eyebrow">For PCA Members Only</div>
          <h2 className="pca-about__headline">
            <span className="pca-about__headline-line">Why PCA members</span>
            <br />
            get this
          </h2>
        </div>
        <p className="pca-about__text">
          I built Bidder iQ for people who can tell a 993 from a 993 C4S across a
          parking lot. That's PCA. Lifetime access isn't offered on our public
          site, and it won't be once this closes.
        </p>
      </div>
    </section>
  );
}

export default PcaAbout;
